import { render, staticRenderFns } from "./NewSlider.vue?vue&type=template&id=56dccef0&lang=pug&"
import script from "./NewSlider.vue?vue&type=script&lang=js&"
export * from "./NewSlider.vue?vue&type=script&lang=js&"
import style0 from "./NewSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports